import { render, staticRenderFns } from "./QbSidebar.vue?vue&type=template&id=36a6387f&scoped=true"
import script from "./QbSidebar.vue?vue&type=script&lang=js"
export * from "./QbSidebar.vue?vue&type=script&lang=js"
import style0 from "./QbSidebar.vue?vue&type=style&index=0&id=36a6387f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36a6387f",
  null
  
)

export default component.exports